import React from "react";

import { cn } from "../../lib/utils";

/**
 * "Border Magic" button inspired by Aceternity's Tailwind CSS buttons.
 * Uses `animate-rotate` (added in tailwind.config.js).
 * Ref: https://www.aceternity.com/blog/moving-border-effect-tailwindcss
 */
export function BorderMagicButton({
  className,
  contentClassName,
  children,
  onClick,
  type = "button",
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      className={cn(
        "group relative inline-flex h-12 items-center justify-center overflow-hidden rounded-xl border border-white/20 p-[1.5px] text-white shadow-2xl transition active:scale-[0.99]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 focus-visible:ring-offset-2 focus-visible:ring-offset-black",
        className
      )}
    >
      <div className="animate-rotate absolute inset-0 h-full w-full rounded-full bg-[conic-gradient(#a78bfa_20deg,transparent_120deg)]" />
      <span
        className={cn(
          "relative z-10 inline-flex h-full w-full items-center justify-center rounded-[0.60rem] bg-black/70 px-8 text-sm font-semibold tracking-wide backdrop-blur",
          contentClassName
        )}
      >
        {children}
      </span>
    </button>
  );
}

